export type ParsedMessage = {
  ref: string | null;
  text: string;
};

const REF_PATTERN = /^<ref label="([^"]+)"\/>\n?([\s\S]*)$/;

export const parseMessageReference = (content: string): ParsedMessage => {
  const match = content.match(REF_PATTERN);
  if (!match) {
    return { ref: null, text: content };
  }
  return { ref: match[1], text: match[2] };
};
